<template>
    <div class="col-12 form-group filter-size pt-2 pb-2 border" id="test-summary"
         :data-element-stats="jsonAnswersStats">
        <div class="row my-1">
            <div class="ml-3">
                <input type="checkbox" v-model="isResultVisible">
            </div>
            <div class="ml-2">
                <label class="h6 font-weight-bold">{{ $lang('Podsumowanie wyników testu') }}</label>
            </div>
        </div>

        <div class="col-12" v-if="isResultVisible">
            <div class="row mt-3 mb-4 pt-2 border-top border-bottom justify-content-center">
                <div style="white-space: nowrap">
                    <input type="checkbox" v-model="isCompletedTestsCountVisible">
                    <label class="mr-3">{{ $lang('Liczba rozwiązanych testów') }}</label>
                </div>
                <div style="white-space: nowrap">
                    <input type="checkbox" v-model="isPassedTestsCountVisible">
                    <label class="mr-3">{{ $lang('Liczba zdanych testów') }}</label>
                </div>
                <div style="white-space: nowrap">
                    <input type="checkbox" v-model="isAverageVisible">
                    <label class="mr-3">{{ $lang('Średnia uzyskanych wyników') }}</label>
                </div>
            </div>

            <div class="row my-2" v-if="isCompletedTestsCountVisible">
                <div class="col-lg-3 col-md-5 col-sm-6 col-7 font-weight-bold">
                    <label>{{ $lang('Liczba rozwiązanych testów:') }}</label>
                </div>
                <div class="col-lg-9 col-md-7 col-sm-6 col-5">
                    <label>{{ completedTestsCount }}</label>
                </div>
            </div>

            <div class="row my-2" v-if="isPassedTestsCountVisible">
                <div class="col-lg-3 col-md-5 col-sm-6 col-7 font-weight-bold">
                    <label>{{ $lang('Liczba zdanych testów:') }}</label>
                </div>
                <div class="col-lg-9 col-md-7 col-sm-6 col-5">
                    <label>{{ passedTestsCount }}</label>
                </div>
            </div>

            <div class="row my-2" v-if="isAverageVisible">
                <div class="col-lg-3 col-md-5 col-sm-6 col-7 font-weight-bold">
                    <label>{{ $lang('Średnia uzyskanych wyników:') }}</label>
                </div>
                <div class="col-lg-9 col-md-7 col-sm-6 col-5">
                    <label>{{ averageOfCorrectAnswersPercentage+'%' }}</label>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "test-summary",
    props: {
        completed_tests_count: Number,
        passed_tests_count: Number,
        average_of_correct_answers_percentage: Number,
    },
    data() {
        return {
            answersStats: null,
            jsonAnswersStats: null,
            completedTestsCount: this.completed_tests_count,
            passedTestsCount: this.passed_tests_count,
            averageOfCorrectAnswersPercentage: this.average_of_correct_answers_percentage,
            isResultVisible: true,
            isCompletedTestsCountVisible: true,
            isPassedTestsCountVisible: true,
            isAverageVisible: true,
        }
    },
    created() {
        this.answersStats = {
            selected: this.isResultVisible,
            completedTestsCount: this.isCompletedTestsCountVisible,
            passedTestsCount: this.isPassedTestsCountVisible,
            average: this.isAverageVisible,
        };
        this.jsonAnswersStats = JSON.stringify(this.answersStats);
    },
    watch: {
        answersStats: {
            handler: function (val, oldVal) {
                this.jsonAnswersStats = JSON.stringify(this.answersStats);
            },
            deep: true
        },
        isResultVisible: function (val) {
            if (!this.isResultVisible) {
                this.answersStats = {
                    selected: this.isResultVisible,
                };
            } else {
                this.answersStats = {
                    selected: this.isResultVisible,
                    completedTestsCount: this.isCompletedTestsCountVisible,
                    passedTestsCount: this.isPassedTestsCountVisible,
                    average: this.isAverageVisible,
                };
                this.jsonAnswersStats = JSON.stringify(this.answersStats);
            }
        },
        isCompletedTestsCountVisible: function (val) {
            this.answersStats.completedTestsCount = val;
        },
        isPassedTestsCountVisible: function (val) {
            this.answersStats.passedTestsCount = val;
        },
        isAverageVisible: function (val) {
            this.answersStats.average = val;
        },
    }
}
</script>

<style scoped>

</style>
